import { Injectable } from "@angular/core"
import * as CryptoJS from 'crypto-js'

@Injectable({
  providedIn: 'root'
})
export class SecureStorageService {

  constructor() {
  }

  init(encryptKey) {
    Storage.prototype._setItem = Storage.prototype.setItem
    Storage.prototype._getItem = Storage.prototype.getItem
    Storage.prototype._clear = Storage.prototype.clear

    Storage.prototype.setItem = function(key, value) {
      this._setItem(key, value);
    }
    
    Storage.prototype.getItem = function(key) {
      let value = this._getItem(key)
      if (value) {
        try {
          JSON.parse(value);
        } 
        catch (e) {
          this._clear;
          return null;
        }
        return value; 
      } 
      return null
    }    
  }
  
}
